import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from 'src/lib/services/activated-route.service';

@Component({
  selector: 'fail',
  templateUrl: './fail.component.html',
  styleUrls: ['./fail.component.scss']
})
export class FailComponent implements OnDestroy {

	private subscriptions: Subscription = new Subscription();

	@Input() errorCode: number = 500

	constructor(private activatedRoute: ActivatedRoute) {

		this.subscriptions.add(
			this.activatedRoute.params.subscribe(params => {
				if(params.errorCode) 
					this.errorCode = params.errorCode
			})
		)
	}

	ngOnDestroy () {
		this.subscriptions.unsubscribe();
	}
}
